import { Routes, Route } from "react-router-dom";
import CashMovementListingPage from "@/pages/financial/cash-movement-listing";

export default function CashMovementListingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CashMovementListingPage />} />
    </Routes>
  );
}
